import { useMutation, useQuery } from "react-query";
import { getRoles, getRolesّForm } from "../../../api/operator/roleApi";
import { getAuthors } from "../../../api/author/authorApi";
import { addFile } from "../../../api/files/filesApi";
import { toast } from "react-toastify";
import { useReRender } from "../contexts/reRenderContext";
import React, { useState, useEffect } from "react";
import { getCategories } from "../../../api/blogs/blogsApi";

export function useCategoryList(rN?: number) {
  return useQuery({
    queryKey: ["categoryList", rN],
    queryFn: async () => {
      const { data } = await getCategories();
      return data;
    },
  });
}

export function useRoleList(rN?: number) {
  return useQuery({
    queryKey: ["roleList", rN],
    queryFn: async () => {
      const { roles } = await getRoles();
      //console.log("INDEX", query)
      return roles;
    },
  });
}

export function useRoleListForm (rN?: number) {
  return useQuery({
    queryKey: ["roleListForm", rN],
    queryFn: async () => {
      const data = await getRolesّForm();
  
      return data.roles || data;
    },
  });
}

export function useGroupList(rN?: number) {
  // return useQuery({
  //   queryKey: ["groupList", rN],
  //   queryFn: async () => {
  //     const {groups} = await getGroups();
  //
  //     return group;
  //   },
  // });
  return { data: [{ _id: "asdasaop2", name: "واحد پشتیبانی" }], error: "" };
}

export function useAuthorList(rN?: number) {
  return useQuery({
    queryKey: ["authorList", rN],
    queryFn: async () => {
      const { data } = await getAuthors();
      return data;
    },
  });
}

export function useFileMutation() {
  const { reRender } = useReRender();
  return useMutation(
    async ({
      formData,
      isLast,
      handleHide,
    }: {
      formData: any;
      isLast: boolean;
      handleHide: any;
    }) => {
      try {
        const data = await addFile(formData);
        if (data.data.status === "failed") {
          throw new Error(data?.data?.data);
        }
        toast.success("با موفقیت ایجاد شد", {
          position: "top-center",
        });

        if (isLast) {
          setTimeout(() => {
            reRender();
          }, 150);
          handleHide();
        }
        return data;
      } catch (error: any) {
        const errorMessage = error?.message || "اشکال در ارسال";
        toast.error(errorMessage, {
          position: "top-center",
        });
      }
    }
  );
}

// export const useResendTimer = (duration, onComplete) => {
//   const [disabled, setDisabled] = useState(false);
//   const [remainingTime, setRemainingTime] = useState(duration);
//
//   useEffect(() => {
//     let timerId;
//
//     const startTimer = () => {
//       setDisabled(true);
//       timerId = setInterval(() => {
//         setRemainingTime((prevTime) => {
//           if (prevTime === 1) {
//             setDisabled(false);
//             clearInterval(timerId);
//             if (onComplete) {
//               onComplete();
//             }
//             return duration;
//           }
//           return prevTime - 1;
//         });
//       }, 1000);
//     };
//
//     startTimer();
//
//     return () => clearInterval(timerId);
//   }, [duration, onComplete]);
//
//   const resetTimer = () => {
//     console.log("from reset timer");
//     setRemainingTime(duration);
//
//   };
//
//   return [disabled, resetTimer, remainingTime];
// };

export const useResendTimer = (initialDuration, onComplete?: any) => {
  const [disabled, setDisabled] = useState(false);
  const [remainingTime, setRemainingTime] = useState(initialDuration);
  const [duration, setDuration] = useState(initialDuration);
  const [reRender, setRerender] = React.useState(0);
  useEffect(() => {
    let timerId;

    const startTimer = () => {
      setDisabled(true);
      timerId = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime === 1) {
            setDisabled(false);
            clearInterval(timerId);
            if (onComplete) {
              onComplete();
            }
            return duration;
          }
          return prevTime - 1;
        });
      }, 1000);
    };

    startTimer();

    return () => clearInterval(timerId);
  }, [duration, onComplete, reRender]);

  const resetTimer = () => {
    setRerender(reRender + 1);
  };

  return [disabled, resetTimer, remainingTime, setDuration];
};
